import { Icon } from '@iconify/react'
import { Stack, Typography, Chip } from '@mui/material'
import React from 'react'

type Props = {}

const GSplatViewerHeader = (props: Props) => {
    return (
        <Stack direction={"row"} alignItems={"center"} gap={2} sx={{
            paddingInline: '1.5rem'
        }}>

            <Icon icon="mdi:arrow-left" style={{
                cursor: 'pointer',
                fontSize: '1.5rem'
            }} onClick={() => history.back()} />

            <Typography variant="h1" style={{
                fontSize: '1.5rem'
            }}>Gaussian Splat Viewer</Typography>

            <Chip 
                label="BETA" 
                size="small"
                sx={{
                    background: 'linear-gradient(45deg, #4169e1, #6495ed, #87ceeb, #4169e1)',
                    backgroundSize: '300% 300%',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '0.7rem',
                    height: '24px',
                    borderRadius: '6px',
                    animation: 'gradientShift 3s ease-in-out infinite',
                    '@keyframes gradientShift': {
                        '0%': {
                            backgroundPosition: '0% 50%'
                        },
                        '50%': {
                            backgroundPosition: '100% 50%'
                        },
                        '100%': {
                            backgroundPosition: '0% 50%'
                        }
                    }
                }}
            />
        </Stack>
    )
}

export default GSplatViewerHeader
